<kve-editor-content-cell>
    <div class="content-cell">
        <div class="input-cell">
            <nb-toggle [checked]="true" labelPosition="start">About Us</nb-toggle>
        </div>
        <div class="input-cell">
            <nb-toggle [checked]="true" disabled labelPosition="start">Blog</nb-toggle>
        </div>
        <div class="input-cell">
            <nb-toggle [checked]="true" labelPosition="start">Careers</nb-toggle>        
        </div>
        <div class="input-cell">
            <nb-toggle [checked]="true" labelPosition="start">Management Profiles</nb-toggle>         
        </div>
    </div>
</kve-editor-content-cell>